import React, { useState, useEffect } from "react";
import { Edit, Trash2, X, Truck } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import DateFormatter from '../../hooks/DateFormatter';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import Pagination from "../../hooks/Pagination";
import { useAuth } from "../../context/AuthContext";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { getordersHistory, getordersStatusLog, updateOrderStatus } from "../../services/api";


export default function Order() {
    const { user } = useAuth();
    useDocumentTitle('Welcome to Admin | Products');
    const [productslist, setProducts] = useState([]);
    const [statuslogs, setStatusLog] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('log');
    const [formData, setFormData] = useState({
        message: '',
        status: '',
        order_id: 0,
    });
    const [formErrors, setFormErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [deletingId, setDeletingId] = useState(null);

    const perPage = 25;

    const fetchordersHistory = async (perPage, currentPage) => {
        try {
            setLoading(true);
            const response = await getordersHistory(perPage, currentPage);
            setProducts(response.data.data || []);
            setCurrentPage(response.current_page);
            setTotalPages(response.last_page);
        } catch (err) {
            console.error('Fetch products error:', err); // Debug log
            setError(err.message || 'Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };
    const fetchordersStatusLog = async (order_id) => {
        try {
            setLoadingStatus(true);
            const response = await getordersStatusLog(order_id);
            setStatusLog(response.data || []);
        } catch (err) {
            console.error('Fetch status log error:', err); // Debug log
            setError(err.message || 'Failed to fetch status log');
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        fetchordersHistory(perPage, currentPage);
    }, [currentPage]);
    const [showDropdown, setShowDropdown] = useState(null);
    const handleCloseModal = () => {
        setShowModal(false);
        resetForm();
        setError('');
        setSuccess('');
    };
    const resetForm = () => {
        setFormData({
            message: '',
            status: '',
            order_id: 0,
        });
        setFormErrors({});
        setSelectedProduct(null);
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };
    const handleStatus = (items, type) => {
        setShowModal(true);
        setModalType(type);
        console.log(items);

        setSelectedProduct(items);
        if (type === 'log') {
            fetchordersStatusLog(items.id);
            setFormData(prev => ({
                ...prev,
                ['order_id']: items.id
            }));
        }

    }
    const statuslist = [
        "PENDING",
        "CONFIRMED",
        "PROCESSING",
        "DISPACHED",
        "DELIVERED",
        "CANCELLED",
        "REFUND INITIATED",
        "REFUNDED"
    ];
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.message.trim()) {
            toastr.error('message is required')
            return false
        }
        if (formData.status === '') {
            toastr.error('status is required')
            return false
        }
        const data = await updateOrderStatus(formData);
        // Handle API response
        if (data.status && data.status.success === true) {
            toastr.success('added successfully!');
            resetForm();
            setError('');
            setSuccess('');
            fetchordersStatusLog(formData.order_id);
        } else {
            toastr.error(data.message)
        }
    }
    return (
        <>
            <div className="flex flex-col md:flex-row gap-4 md:gap-4">

                <div className="w-full bg-white shadow-lg rounded-2xl p-6">
                    <div className="grid grid-flow-col grid-rows-3 gap-4">
                        <div className="row-start-1 row-end-4">
                            <h2 className="text-2xl font-bold mb-4">Products Order List</h2>
                        </div>

                    </div>
                    <div className="overflow-auto">
                        <table className="w-full text-sm text-left">
                            <thead className="text-gray-700 bg-gray-100">
                                <tr>
                                    <th className="p-3">SL No.</th>
                                    <th className="p-3">Trx Date</th>
                                    <th className="p-3">Order Number</th>
                                    <th className="p-3">Customer</th>
                                    <th className="p-3">Quantity</th>
                                    <th className="p-3">Total GTcoin</th>
                                    <th className="p-3">Order Status</th>
                                    <th className="p-3 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y">
                                {loading ? (
                                    <tr>
                                        <td className="p-3" colSpan={8}>
                                            <ShimmerLoader />
                                            <ShimmerLoader />
                                            <ShimmerLoader />
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {!loading && productslist.length > 0 ? (
                                            productslist.map((item, key) => (
                                                <tr key={item.id}>
                                                    <td className="p-3">{key + 1}</td>
                                                    <td className="p-3">{DateFormatter(item.created_at, 'dd-MMM-yy h:mm a')}</td>
                                                    <td className="p-3" nowrap="true">{item.order_number}</td>
                                                    <td className="p-3">
                                                        {item.customer.name}<br />
                                                        +{item.customer.countrycode}{item.customer.mobile}
                                                    </td>
                                                    <td className="p-3"> {item.items.length}</td>
                                                    <td className="p-3">{item.total_amount}</td>
                                                    <td className="p-3">{item.order_status_text}</td>
                                                    <td className="p-3 text-center">
                                                        <div className="relative inline-block text-left">
                                                            <button
                                                                type="button"
                                                                className="inline-flex items-center justify-center w-8 h-8 text-gray-500 hover:text-[#f4a406] hover:bg-gray-100 rounded-full transition-colors"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setShowDropdown(showDropdown === item.id ? null : item.id);
                                                                }}
                                                                disabled={deletingId === item.id}
                                                            >
                                                                {deletingId === item.id ? (
                                                                    <div className="w-4 h-4 border-2 border-[#f4a406] border-t-transparent rounded-full animate-spin"></div>
                                                                ) : (
                                                                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 16 16">
                                                                        <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                                                    </svg>
                                                                )}
                                                            </button>

                                                            {showDropdown === item.id && (
                                                                <div className="absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                                    <div className="py-1">
                                                                        <button
                                                                            onClick={() => {
                                                                                handleStatus(item, 'log');
                                                                                setShowDropdown(null);
                                                                            }}
                                                                            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                                        >
                                                                            <Truck size={14} />
                                                                            Update Status
                                                                        </button>
                                                                        <button
                                                                            onClick={() => {
                                                                                handleStatus(item, 'details');
                                                                                setShowDropdown(null);
                                                                            }}
                                                                            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                                        >
                                                                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                            </svg>
                                                                            Order Details
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="p-3 text-center" colSpan={8}>
                                                    No products found
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )}
                            </tbody>
                        </table>
                        <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                    </div>
                </div>
            </div>
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white rounded-2xl w-full max-w-2x1"> {/* Increased from max-w-md to max-w-2xl */}
                        <div className="flex justify-between items-center p-6 border-b">
                            <h3 className="text-xl font-bold">
                                {modalType === 'details' ? 'Order Details' : 'Update Delivery Status'}
                            </h3>
                            <button
                                onClick={handleCloseModal}
                                className="text-gray-500 hover:text-gray-700"
                                disabled={submitting}
                            >
                                <X size={24} />
                            </button>
                        </div>
                        {modalType === 'details' ? (
                            <>
                                <div className="grid grid-cols-2 md:grid-cols-2 gap-4 p-6">
                                    <div>
                                        <table className="w-full text-sm text-left">
                                            <thead className="divide-y">
                                                <tr>
                                                    <td className="p-3 text-gray-700 bg-gray-100">Order Number</td>
                                                    <td className="p-3" nowrap="true">{selectedProduct?.order_number}</td>
                                                </tr>
                                                <tr>
                                                    <td className="p-3 text-gray-700 bg-gray-100">Status</td>
                                                    <td className="p-3" nowrap="true">{selectedProduct?.order_status_text}</td>
                                                </tr>
                                                <tr>
                                                    <td className="p-3 text-gray-700 bg-gray-100">GTcoin</td>
                                                    <td className="p-3" nowrap="true">{selectedProduct?.total_amount}</td>
                                                </tr>
                                                <tr>
                                                    <td className="p-3 text-gray-700 bg-gray-100">Customer</td>
                                                    <td className="p-3" nowrap="true">{selectedProduct?.customer?.name} , +{selectedProduct?.customer?.countrycode} {selectedProduct?.customer?.mobile}</td>
                                                </tr>
                                                <tr>
                                                    <td className="p-3 text-gray-700 bg-gray-100">Order On</td>
                                                    <td className="p-3" nowrap="true">{DateFormatter(selectedProduct?.created_at, 'dd-MMM-yy h:mm a')}</td>
                                                </tr>
                                                <tr>
                                                    <td className="p-3 text-gray-700 bg-gray-100">Note</td>
                                                    <td className="p-3">{selectedProduct?.notes}</td>
                                                </tr>
                                            </thead>

                                        </table>
                                    </div>
                                    <div>
                                        <table className="w-full text-sm text-left">
                                            <thead >
                                                <tr>
                                                    <th className="p-3" colSpan={4}>Item List</th>
                                                </tr>
                                                <tr>
                                                    <th className="p-3 text-gray-700 bg-gray-100">SL No.</th>
                                                    <th className="p-3 text-gray-700 bg-gray-100">Product Name</th>
                                                    <th className="p-3 text-gray-700 bg-gray-100">Qty.</th>
                                                    <th className="p-3 text-gray-700 bg-gray-100">Price</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y">
                                                {loadingStatus ? (
                                                    <tr>
                                                        <td className="p-3" colSpan={8}>
                                                            <ShimmerLoader />
                                                            <ShimmerLoader />
                                                            <ShimmerLoader />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {!loadingStatus && selectedProduct?.items.length > 0 ? (
                                                            selectedProduct?.items.map((item, key) => (
                                                                <tr key={item.order_id}>
                                                                    <td className="p-3">{key + 1}</td>
                                                                    <td className="p-3" nowrap="true">{item.product_name}</td>
                                                                    <td className="p-3" nowrap="true">{item.qty}</td>
                                                                    <td className="p-3">{item.price}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td className="p-3 text-center" colSpan={8}>
                                                                    No items found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="grid grid-cols-1 md:grid-cols-1 gap-4 p-6">
                                    <table className="w-full text-sm text-left">
                                        <thead className="text-gray-700 bg-gray-100">
                                            <tr>
                                                <th className="p-3">SL No.</th>
                                                <th className="p-3">Trx Date</th>
                                                <th className="p-3">Order Number</th>
                                                <th className="p-3">Message</th>
                                                <th className="p-3">Order Status</th>
                                                <th className="p-3">Updated By</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y">
                                            {loadingStatus ? (
                                                <tr>
                                                    <td className="p-3" colSpan={8}>
                                                        <ShimmerLoader />
                                                        <ShimmerLoader />
                                                        <ShimmerLoader />
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {!loadingStatus && statuslogs.length > 0 ? (
                                                        statuslogs.map((item, key) => (
                                                            <tr key={item.id}>
                                                                <td className="p-3">{key + 1}</td>
                                                                <td className="p-3">{DateFormatter(item.created_at, 'dd-MMM-yy h:mm a')}</td>
                                                                <td className="p-3" nowrap="true">{item.order.order_number}</td>
                                                                <td className="p-3" nowrap="true">{item.message}</td>
                                                                <td className="p-3">{item.status_text}</td>
                                                                <td className="p-3">
                                                                    {item.updated_by.name}<br />
                                                                    +{item.updated_by.countrycode}{item.updated_by.mobile}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td className="p-3 text-center" colSpan={8}>
                                                                No products found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <form onSubmit={handleSubmit} className="p-6">
                                    <div className="grid grid-cols-3 md:grid-cols-4 gap-4">
                                        <div className="md:col-span-2"> {/* Full width */}
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Message*
                                            </label>
                                            <input
                                                type="text"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleInputChange}
                                                className={`w-full p-2 border rounded-lg focus:ring-2 focus:ring-[#f4a406] focus:border-transparent ${formErrors.message ? 'border-red-500' : 'border-gray-300'
                                                    }`}
                                                placeholder="Enter Message"
                                                disabled={submitting}
                                            />
                                            {formErrors.message && (
                                                <p className="text-red-500 text-xs mt-1">{formErrors.message}</p>
                                            )}
                                        </div>

                                        {/* Product Type Dropdown */}
                                        <div className="md:col-span-2"> {/* Full width */}
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Status*
                                            </label>
                                            <select
                                                name="status"
                                                value={formData.status}
                                                onChange={handleInputChange}
                                                className={`w-full p-2 border rounded-lg focus:ring-2 focus:ring-[#f4a406] focus:border-transparent ${formErrors.status ? 'border-red-500' : 'border-gray-300'
                                                    }`}
                                                disabled={submitting}
                                            >
                                                <option value="">Select Status Type</option>
                                                {statuslist && statuslist.map((item, index) =>
                                                    <option key={item} value={index}>{item}</option>
                                                )}
                                            </select>
                                            {formErrors.status && (
                                                <p className="text-red-500 text-xs mt-1">{formErrors.status}</p>
                                            )}
                                        </div>

                                    </div>

                                    <div className="flex gap-3 mt-6">
                                        <button
                                            type="button"
                                            onClick={handleCloseModal}
                                            className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                                            disabled={submitting}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={submitting}
                                            className="flex-1 py-2 px-4 bg-[#f4a406] text-white rounded-lg hover:bg-[#d89005] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            {submitting ? 'Saving...' : 'Add'}
                                        </button>
                                    </div>
                                </form>
                            </>
                        )}

                    </div>
                </div >
            )
            }

        </>
    );
}